export default __webpack_public_path__ + "static/media/faithinset.1690370f.png";